import React, { useState, useEffect } from "react";
import expandFullscreen from "../../../../../../assets/icons/expandFullscreen.svg";
import exitFullscreen from "../../../../../../assets/icons/exitFullscreen.svg";
import "./FullscreenPageIcon.scss";

const FullscreenPageIcon = () => {
   const [isFullscreen, setIsFullscreen] = useState(document.fullscreenElement);

   const toggleFullscreen = () => {
      if (!document.fullscreenElement) {
         document.documentElement.requestFullscreen();
      } else {
         document.exitFullscreen();
      }
   };

   useEffect(() => {
      const fullscreenChangeHandler = () => {
         setIsFullscreen(!!document.fullscreenElement);
      };
      document.addEventListener("fullscreenchange", fullscreenChangeHandler);
      document.addEventListener("webkitfullscreenchange", fullscreenChangeHandler);
      document.addEventListener("mozfullscreenchange", fullscreenChangeHandler);
      document.addEventListener("MSFullscreenChange", fullscreenChangeHandler);
      return () => {
         document.removeEventListener("fullscreenchange", fullscreenChangeHandler);
         document.removeEventListener("webkitfullscreenchange", fullscreenChangeHandler);
         document.removeEventListener("mozfullscreenchange", fullscreenChangeHandler);
         document.removeEventListener("MSFullscreenChange", fullscreenChangeHandler);
      };
   }, []);

   useEffect(() => {
      if (!window.visualViewport) return;

      const handleViewportResize = () => {
         if (!document.fullscreenElement) return;
         const surveyContainer = document.querySelector(".survey-previewer");
         if (surveyContainer) {
            const heightDiff = window.innerHeight - window.visualViewport.height;
            surveyContainer.style.paddingBottom =
               heightDiff > 100 ? `${heightDiff + 30}px` : "30px";
         }
      };

      window.visualViewport.addEventListener("resize", handleViewportResize);
      return () => {
         window.visualViewport.removeEventListener("resize", handleViewportResize);
      };
   }, []);

   return (
      <div className="fullscreen-icon" onClick={toggleFullscreen}>
         {isFullscreen ? (
            <img src={exitFullscreen} alt="Exit Fullscreen" className="fullscreen-icon__image" />
         ) : (
            <img src={expandFullscreen} alt="Enter Fullscreen" className="fullscreen-icon__image" />
         )}
      </div>
   );
};

export default FullscreenPageIcon;
